<template>
  <div>
    <div @click="openDrawer = true">
      <slot></slot>
    </div>

    <el-drawer v-model="openDrawer">
      <!--      :append-to-body=true -->
      <el-row>
        <el-col :span="24">
          <el-table
              :highlightCurrentRow=true
              :data="tableData"
              :height="750"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                type="selection"
            ></el-table-column>
            <template v-for="item in columns">
              <el-table-column
                  :prop="item.name"
                  :label="item.label"
              >
                <template #default="scope">
                  <el-tooltip :content="scope.row[item.name]" placement="bottom" effect="light">
                    <omit-text>{{ scope.row[item.name] }}</omit-text>
                  </el-tooltip>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </el-col>
        <el-col :span="24">
          <br/>
          <el-button @click="complete">确定</el-button>
        </el-col>
      </el-row>
    </el-drawer>
  </div>

</template>

<script>
import {commonGet} from "@/request";

export default {
  name: "index",
  emits: {
    data: null,
  },
  data() {
    return {
      openDrawer: false,
      tableData: [],
      result: []
    }
  },
  props: ['url', 'columns'],
  created() {
    commonGet(this.url).then(res => {
      this.tableData = res.data
    })
  },

  methods: {
    complete() {
      let index = 0
      let result = this.result.map(item => {
        item.id = null
        item.sort = index++
        return item
      })
      console.log(result)
      this.$emit('data', result)
      this.openDrawer = false
    },
    handleSelectionChange(val) {
      this.result = val
    }
  }
}
</script>

<style scoped>

</style>
